import { render, staticRenderFns } from "./CartViewB2C.vue?vue&type=template&id=95b5b3a8&"
import script from "./CartViewB2C.ts?vue&type=script&lang=ts&"
export * from "./CartViewB2C.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports